import { Base } from "@studiometa/js-toolkit";
import { domScheduler } from "@studiometa/js-toolkit/utils";
import { setHeaderVisibility, headerIsVisible } from "../store/header.js";
class HeaderSwitcher extends Base {
  /**
   * Config.
   */
  static config = {
    name: "HeaderSwitcher",
    refs: ["show", "hide"]
  };
  mounted() {
    this.update(headerIsVisible());
  }
  onShowClick() {
    this.show();
  }
  onHideClick() {
    this.hide();
  }
  show() {
    setHeaderVisibility("visible");
    this.update(headerIsVisible());
    this.$refs.hide.focus();
  }
  hide() {
    setHeaderVisibility("hidden");
    this.update(headerIsVisible());
    this.$refs.show.focus();
  }
  update(isVisible) {
    domScheduler.write(() => {
      this.$refs.hide.classList.toggle("flex", isVisible);
      this.$refs.show.classList.toggle("flex", !isVisible);
      this.$refs.hide.classList.toggle("hidden", !isVisible);
      this.$refs.show.classList.toggle("hidden", isVisible);
    });
  }
}
export {
  HeaderSwitcher as default
};
//# sourceMappingURL=HeaderSwitcher.js.map
